
import { Layout, Menu } from 'antd';
import { HomeOutlined,DollarOutlined,ShopOutlined, AlertOutlined, TeamOutlined, UserOutlined, LineChartOutlined, TableOutlined, PieChartOutlined,CarOutlined, SmileOutlined} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { SubMenu } = Menu;
const { Sider } = Layout;

const AdminSider = ()=>{

    return(
      <Sider
      breakpoint="lg"
      collapsedWidth="0"
      width={250}
      onBreakpoint={broken => {
      }}
      onCollapse={(collapsed, type) => {
      }}
    >

      <Menu theme="dark" mode="inline">
        

      <Menu.Item key="1" icon={<HomeOutlined />}>
          <Link to='/'>Log Out</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<LineChartOutlined />}>
          <Link to='/DashBoard'>DashBoard</Link>
        </Menu.Item>
 
        <SubMenu key='subVehicle' title='Vehicle' icon={<CarOutlined />}>
          <Menu.Item key="Vehicle1" icon={<TableOutlined />}>
            <Link to='/Vehicle'>Vehicle</Link>
          </Menu.Item>
          <Menu.Item key='Vehicle3' icon={<TableOutlined />}>
            <Link to="/Makes">Make</Link>
          </Menu.Item>
          <Menu.Item key='Vehicle4' icon={<TableOutlined />}>
            <Link to='/Model'>Model</Link>
          </Menu.Item>
          <Menu.Item key='Vehicle5' icon={<TableOutlined />}>
            <Link to='/Task'>Task</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu key='subSales' title='Sales' icon={<DollarOutlined />}>
          <Menu.Item key="Sales1" icon={<TableOutlined />}>
            <Link to="/Sales">Sales</Link>
          </Menu.Item>
          <Menu.Item key='Sales2' icon={<PieChartOutlined />}>
          <Link to="/SalesModel">Sales by Model</Link>
          </Menu.Item>
          <Menu.Item key='Sales3' icon={<PieChartOutlined />}>
          <Link to="/SalesByDate">Sales by Date</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu key='subCustomer' title='Customer' icon={<SmileOutlined/>}>
          <Menu.Item key="Customer1" icon={<UserOutlined />}>
            <Link to="/Customer">Customer</Link>
          </Menu.Item>

        </SubMenu>

        <SubMenu key='subAuction' title='Auction' icon={<AlertOutlined />}>
          <Menu.Item key="Auction1" icon={<ShopOutlined />}>
            <Link to='/Auction'>Auction</Link>
          </Menu.Item>
          <Menu.Item key='Acution2' icon={<PieChartOutlined />}>
            <Link to='/AuctionRep'>Report</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu key='subEmployee' title='Staff Management' icon={<TeamOutlined />}>
          <Menu.Item key="Employee1" icon={<UserOutlined />}>
            <Link to='/Employee'>Employee</Link>
          </Menu.Item>
          <Menu.Item key='Labor' icon={<TableOutlined />}>
            <Link to='/Labor'>Labor</Link>
          </Menu.Item>
        </SubMenu>

      </Menu>
    </Sider>
    )

}
export default AdminSider